import { CompanyLocation } from '@bo-client/shared/models/companyLocations';
import { ContactDataDto } from '@bo-client/shared/models/contactDataDto';
import { DocumentDto } from '@bo-client/shared/models/documentDto';

export interface TechnicianRegistration {
  companyType: string; // type this (at least an enum)
  companyLocation: CompanyLocation;
  selectedAreas: string[]; // TODO make a type for area
  company: CompanyRegistration;
  contacts: ContactRegistration[];
}

export interface CompanyRegistration {
  address: ContactDataDto;
  uploads: DocumentDto;
}

export interface ContactRegistration {
  areas: AreaItem[];
  contactData: ContactDataDto;
  uploads: DocumentDto;
  isMainContact: boolean;
}
export enum AreaEnum {
  POWER = 'POWER',
  GAS = 'GAS',
  WATER = 'WATER'
}

export interface AreaItem {
  name: string;
  selected: boolean;
}

export interface UploadDocumentQuestion {
  title?: string;
  displayName?: string;
  info?: string;
  type: string;
  required: boolean;
  cokDocId?: string;
  uploadFileName?: string;
}

export class CurrentLocationModel {
  areaName = '';
  areaTypes: string[] = [];
}
export type InstallerPassStatusType =
  | 'Initialized'
  | 'PendingDocuments'
  | 'DocumentsComplete'
  | 'RequestValidation'
  | 'ReadyToValidate'
  | 'Valid'
  | 'Invalid'
  | 'Inactive'
  | 'Expired'
  | 'Rejected'
  | 'FeedbackNeeded'
  | 'RequestRenew';

export enum InstallerPassStatusEnum {
  Initialized = 'Initialized',
  PendingDocuments = 'PendingDocuments',
  DocumentsComplete = 'DocumentsComplete',
  RequestValidation = 'RequestValidation',
  ReadyToValidate = 'ReadyToValidate',
  Valid = 'Valid',
  Invalid = 'Invalid',
  Inactive = 'Inactive',
  Expired = 'Expired',
  Rejected = 'Rejected',
  FeedbackNeeded = 'FeedbackNeeded'
}
